<style scoped>
    .vue-statuses-container {
        height: 44px;
    }
</style>

<template>
    <div>
        <div class="col-md-12">
            <label style="font-size: 15px">
                <input type="checkbox"
                       @change="selectAllStatuses()"
                       v-model="is_chosen_all_statuses" />
                {{ translations.select_all }}
            </label>
        </div>
        <br>
        <div class="col-md-12">
            <div class="col-md-2 vue-statuses-container" v-for="status in statuses">
                <div class="form-group">
                    <label>
                        <input type="checkbox"
                               name="statuses[]"
                               :value="status.id"
                               v-model="chosen_statuses" />
                        {{ status.title }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['statuses', 'translations'],
        data() {
            return {
                chosen_statuses: [],
                is_chosen_all_statuses: true,
            };
        },
        mounted() {
            this.chosen_statuses = this.pluckIds(this.statuses);
        },
        methods: {
            selectAllStatuses() {
                this.chosen_statuses = this.is_chosen_all_statuses
                    ? this.pluckIds(this.statuses)
                    : [];
            },
            pluckIds(statuses) {
                let ids = [];

                statuses.map((status) => {
                    ids.push(status.id);
                });

                return ids;
            },
        },
        watch: {
            chosen_statuses() {
                this.$emit('update-statuses', this.chosen_statuses);
            }
        }
    };
</script>
